import { render, staticRenderFns } from "./shipping-center.vue?vue&type=template&id=ce61834e&scoped=true"
import script from "./shipping-center.vue?vue&type=script&lang=js"
export * from "./shipping-center.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce61834e",
  null
  
)

export default component.exports